
import {
    ERROR_CREATE_ACTION_TYPE,
    ERROR_CLEAR_ACTION_TYPE,
    ERROR_OPERATION_START_ACTION_TYPE,
    ERROR_OPERATION_SUCCESS_ACTION_TYPE,
    ERROR_OPERATION_NOT_SUCCESS_ACTION_TYPE
} from '../sagas/operationStatus';

const initialState = {
    errors: [],
    operationStart: null,
    operationSuccess: null,
    operationNotSuccess: null
};

export default function operationStatus(state = initialState, action) {
    switch (action.type) {
        case ERROR_CREATE_ACTION_TYPE:
            return {
                ...state,
                errors: [
                    ...state.errors,
                    action.error.toString()
                ]
            };

        case ERROR_CLEAR_ACTION_TYPE:
            return {
                ...state,
                errors: []
            };

        case ERROR_OPERATION_START_ACTION_TYPE:
            return {
                ...state,
                operationStart: action.operation
            };

        case ERROR_OPERATION_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                operationStart: null,
                operationSuccess: action.operation
            };

        case ERROR_OPERATION_NOT_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                operationStart: null,
                operationNotSuccess: action.operation
            };

        default:
            return state
    }
}
